import { useQuery } from "@apollo/client";
import { ReactNode } from "react";
import { GET_CURRENT_USER_PROTECTION_TOKEN } from "../../api/get-current-user-protection-tokens";
import { UserProtectionTokensContext } from "./context";

export function UserProtectionTokensProvider({
  children,
}: {
  children: ReactNode;
}) {
  const { data } = useQuery(GET_CURRENT_USER_PROTECTION_TOKEN);

  if (!data) {
    return null;
  }

  return (
    <UserProtectionTokensContext.Provider
      value={{
        tokens: data.getCurrentUserProtectionTokens,
      }}
    >
      {children}
    </UserProtectionTokensContext.Provider>
  );
}
